// src/pages/LotsPublics.js
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getLotsPublics } from "../services/db";
import { getDoc } from "firebase/firestore";
import { tombolaRef } from "../services/db";
import { QRCodeSVG } from "qrcode.react";

export default function LotsPublics() {
  const { orgId, tombolaId } = useParams();
  const [lots, setLots] = useState([]);
  const [tombola, setTombola] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQR, setShowQR] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    async function load() {
      const [lotsData, tombolaSnap] = await Promise.all([
        getLotsPublics(orgId, tombolaId),
        getDoc(tombolaRef(orgId, tombolaId)),
      ]);
      setLots(lotsData);
      if (tombolaSnap.exists()) setTombola({ id: tombolaSnap.id, ...tombolaSnap.data() });
      setLoading(false);
    }
    load();
  }, [orgId, tombolaId]);

  function copyUrl() {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  }

  if (loading) return <div style={s.center}>⏳ Chargement des lots…</div>;

  const tirageEffectue = lots.some((l) => l.gagnantBilletId);

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.header}>
          <img src="https://app.tombo.live/logo_app.png" alt="TomboLive" style={s.logo} />
          {tombola && <div style={s.headerSub}>{tombola.nom} {tombola.annee}</div>}
        </div>

        <div style={s.body}>
          <h2 style={s.pageTitle}>🎁 Les lots à gagner</h2>

          <div style={s.actionsRow}>
            <button onClick={copyUrl} style={s.btnCopy}>
              {copied ? "✅ Copié !" : "📋 Copier le lien"}
            </button>
            <button onClick={() => setShowQR(!showQR)} style={s.btnQR}>
              📱 QR Code
            </button>
          </div>

          {showQR && (
            <div style={s.qrBox}>
              <p style={s.qrTitle}>Scannez pour voir les lots</p>
              <QRCodeSVG value={window.location.href} size={220} level="M" fgColor="#1a3a8f" />
            </div>
          )}

          {lots.length === 0 ? (
            <p style={s.empty}>Aucun lot enregistré.</p>
          ) : (
            lots.map((lot) => (
              <div key={lot.id} style={s.lotRow}>
                <div style={s.lotLeft}>
                  <span style={s.lotRang}>{lot.rang}e prix</span>
                  <span style={s.lotDesc}>{lot.description}</span>
                  {lot.valeur && <span style={s.lotVal}>{lot.valeur}</span>}
                  {lot.offertPar && <span style={s.offertPar}>🤝 {lot.offertPar}</span>}
                </div>
                <div>
                  {lot.gagnantBilletId ? (
                    <span style={s.gagnant}>🏆 n°{lot.gagnantNumero} · {lot.gagnantNomPublic || lot.gagnantNom}</span>
                  ) : (
                    <span style={s.suspense}>🎰 À venir</span>
                  )}
                </div>
              </div>
            ))
          )}

          {!tirageEffectue && (
            <div style={s.suspenseBox}>
              🤫 Les gagnants seront révélés lors du tirage !
            </div>
          )}
        </div>

        <div style={s.marketingBox}>
          <div style={s.marketingTitle}>🎟️ Vous organisez aussi une tombola ?</div>
          <div style={s.marketingText}>Gérez vos ventes et tirage au sort en quelques clics. <strong>Essayez TomboLive gratuitement !</strong></div>
          <a href="https://tombo.live" target="_blank" rel="noopener noreferrer" style={s.marketingBtn}>Découvrir TomboLive →</a>
        </div>
        <div style={s.footer}>TomboLive · <a href="https://tombo.live" style={{color:"#bbb"}}>tombo.live</a></div>
      </div>
    </div>
  );
}

const s = {
  center:{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",color:"#667eea"},
  wrapper:{minHeight:"100vh",background:"linear-gradient(135deg,#1a3a8f,#0099cc)",display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"1.5rem 1rem"},
  card:{background:"#fff",borderRadius:"20px",width:"100%",maxWidth:"480px",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,0.2)"},
  header:{background:"linear-gradient(135deg,#1a3a8f,#0099cc)",padding:"1.25rem 1rem 1rem",textAlign:"center",overflow:"hidden"},
  logo:{width:"80px",height:"80px",objectFit:"contain",borderRadius:"12px"},
  headerSub:{color:"rgba(255,255,255,0.8)",fontSize:"0.88rem"},
  body:{padding:"1.25rem"},
  pageTitle:{fontSize:"1.1rem",fontWeight:"700",color:"#1a1a2e",marginBottom:"1rem",textAlign:"center"},
  actionsRow:{display:"flex",gap:"10px",marginBottom:"1rem",justifyContent:"center"},
  btnCopy:{padding:"0.6rem 1rem",background:"#eef0ff",color:"#4c5ee8",border:"1px solid #c7d2ff",borderRadius:"8px",cursor:"pointer",fontWeight:"600",fontSize:"0.85rem"},
  btnQR:{padding:"0.6rem 1rem",background:"linear-gradient(135deg,#1a3a8f,#0099cc)",color:"#fff",border:"none",borderRadius:"8px",cursor:"pointer",fontWeight:"600",fontSize:"0.85rem"},
  qrBox:{background:"#f8f9ff",borderRadius:"12px",padding:"1.25rem",textAlign:"center",marginBottom:"1rem",border:"1.5px solid #c7d2ff"},
  qrTitle:{fontWeight:"700",color:"#1a3a8f",fontSize:"0.9rem",marginBottom:"0.75rem"},
  lotRow:{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0.85rem",background:"#f7f8fc",borderRadius:"10px",marginBottom:"8px",gap:"8px"},
  lotLeft:{display:"flex",flexDirection:"column",gap:"3px"},
  lotRang:{fontSize:"0.72rem",fontWeight:"700",color:"#aaa",textTransform:"uppercase"},
  lotDesc:{fontWeight:"600",color:"#1a1a2e",fontSize:"0.92rem"},
  lotVal:{background:"#f0f0f0",color:"#555",fontSize:"0.75rem",padding:"2px 8px",borderRadius:"4px",alignSelf:"flex-start"},
  offertPar:{fontSize:"0.75rem",color:"#2e7d32",fontStyle:"italic"},
  gagnant:{background:"#fff3cd",color:"#856404",fontSize:"0.78rem",fontWeight:"700",padding:"4px 10px",borderRadius:"20px"},
  suspense:{background:"#eef0ff",color:"#4c5ee8",fontSize:"0.78rem",fontWeight:"600",padding:"4px 10px",borderRadius:"20px"},
  empty:{textAlign:"center",color:"#aaa",padding:"2rem",fontStyle:"italic"},
  suspenseBox:{background:"#eef0ff",borderRadius:"10px",padding:"1rem",textAlign:"center",fontSize:"0.88rem",color:"#4c5ee8",fontWeight:"600",margin:"1rem 0"},
  marketingBox:{margin:"1rem 0 0",background:"linear-gradient(135deg,#1a3a8f,#764ba2)",borderRadius:"12px",padding:"1.25rem",textAlign:"center"},
  marketingTitle:{fontWeight:"800",color:"#fff",fontSize:"0.95rem",marginBottom:"8px"},
  marketingText:{fontSize:"0.82rem",color:"rgba(255,255,255,0.85)",lineHeight:1.6,marginBottom:"14px"},
  marketingBtn:{display:"inline-block",padding:"8px 20px",background:"#fff",color:"#1a3a8f",borderRadius:"20px",textDecoration:"none",fontWeight:"700",fontSize:"0.85rem"},
  footer:{textAlign:"center",padding:"0.5rem",fontSize:"0.72rem",color:"#bbb"},
};
